import { render, staticRenderFns } from "./MaterialReport.vue?vue&type=template&id=4dcdeefa&scoped=true"
import script from "./MaterialReport.vue?vue&type=script&lang=js"
export * from "./MaterialReport.vue?vue&type=script&lang=js"
import style0 from "./MaterialReport.vue?vue&type=style&index=0&id=4dcdeefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcdeefa",
  null
  
)

export default component.exports